import React from 'react';
import { Icon } from '../../../../../';
import { PRODUCT_STATUS } from '../productsStatus';
import { ProductCrossActivationButton } from './ProductCrossActivationButton';
export var ProductCrossActivationStatus = function ProductCrossActivationStatus(_ref) {
  var status = _ref.status,
      features = _ref.features,
      inverted = _ref.inverted,
      swicusOrgId = _ref.swicusOrgId;

  if (status === PRODUCT_STATUS.CURRENT_PRODUCT) {
    return /*#__PURE__*/React.createElement(Icon, {
      "data-qa": "current-product-icon",
      className: "product-check",
      name: "check"
    });
  }

  var crossActivationEnabled = features && features.crossActivation;
  if (!crossActivationEnabled || !swicusOrgId) return null;
  return /*#__PURE__*/React.createElement(ProductCrossActivationButton, {
    status: status,
    inverted: inverted
  });
};